import RedirectorSSP from 'src/redirector/Redirector.ssp';

export default function RedirectorFirstLevel() {
  return null;
}

export const getServerSideProps = RedirectorSSP;
